import { render, staticRenderFns } from "./Nueva_membresia.vue?vue&type=template&id=44b11afa&"
import script from "./Nueva_membresia.vue?vue&type=script&lang=js&"
export * from "./Nueva_membresia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports